export var TypeActionActionButton;
(function (TypeActionActionButton) {
    TypeActionActionButton["FocusOutskirtsBuilding"] = "ActionButton > FocusBuilding";
    TypeActionActionButton["AddIteration"] = "ActionButton > AddIteration";
    TypeActionActionButton["ResetIterations"] = "ActionButton > ResetIterations";
})(TypeActionActionButton || (TypeActionActionButton = {}));
export var actionActionButtonFocusBuilding = function (outskirtBuildingId) { return ({
    outskirtBuildingId: outskirtBuildingId,
    type: TypeActionActionButton.FocusOutskirtsBuilding,
}); };
export var actionActionButtonAddIteration = function (buttonId) { return ({
    actionButtonId: buttonId,
    type: TypeActionActionButton.AddIteration,
}); };
export var actionActionButtonResetIteration = function (buttonId) { return ({
    actionButtonId: buttonId,
    type: TypeActionActionButton.ResetIterations,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/hud-action-button/actionHudActionButton.ts
// module id = 178
// module chunks = 3